module.exports = __webpack_public_path__ + "img/supervisor-intro-six.2f8ce7b1.png";